export const ENTITY_TAB_EMAILS_DEFAULT_QA_NAME = 'entityTabEmails'

export const ENTITY_TAB_EMAILS_ADD_BUTTON_QA_NAME = 'entityTabEmailsAddNew'

export const ENTITY_TAB_EMAILS_MESSAGE_QUERY_PARAM_KEY = 'email_message_uuid'

export const ENTITY_TAB_EMAILS_ACTION = {
  AddNote: 'add_note',
  DeleteCopy: 'delete_copy',
  OpenInNewTab: 'open_in_new_tab',
  ViewOriginalEmail: 'view_original_email',
}

export const ENTITY_TAB_EMAILS_STATE_KEYS = {
  EmptyStateKey: 'EntityTabEmails.NoDataKey',
  ErrorStateKey: 'EntityTabEmails.ErrorStateKey',
}

export const ENTITY_TAB_EMAILS_ACTION_LABEL_KEY = {
  [ENTITY_TAB_EMAILS_ACTION.AddNote]: 'Emails.AddNoteActionOptionKey',
  [ENTITY_TAB_EMAILS_ACTION.DeleteCopy]: 'EntityTabEmails.DeleteCopyActionKey',
  [ENTITY_TAB_EMAILS_ACTION.OpenInNewTab]: 'Emails.OpenInNewTabActionOptionKey',
  [ENTITY_TAB_EMAILS_ACTION.ViewOriginalEmail]:
    'EntityTabEmails.ViewOriginalEmailActionKey',
}

export const ENTITY_TAB_EMAILS_DELETE_COPY_CONFIRMATION = {
  DescriptionKey: 'EntityTabEmails.DeleteCopyConfirmationTextKey',
  SubmitKey: 'Modal.CommonRemoveBtnKey',
}
